import { render } from "./App.vue?vue&type=template&id=51d086cd"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=51d086cd&lang=less"

import exportComponent from "/builds/maizhensheng/app-commonapply-v6/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__